module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/strumenti_pic_pro.9ebccb3b.png";